<div class="summary-notes-popup">
    <div class="popup-header-wrapper">
        <div class="popup-title">
            {{title | translate | async}}
        </div>
        <i class="material-icons popup-close-icon" (click)="onNoClick()" matTooltip="Close">
            close
        </i>
    </div>
    <div class="new-comment-section">
        <div class="textarea-wrapper">
            <textarea class="comment-textarea" [(ngModel)]="newComment" autocomplete="off" autocorrect="off"
                autocapitalize="off" spellcheck="false" maxlength="1000" (input)="onCommentInput()"
                [placeholder]="'Enter Equipment Summary Notes...' | translate | async">
            </textarea>
            <div class="character-count">
                <span *ngIf="remainingCharacters > 0" [ngClass]="{
                      'count-warning': remainingCharacters <= 50
                    }">
                    {{ remainingCharacters }}
                    {{'characters remaining' | translate | async}}
                </span>
                <span *ngIf="remainingCharacters === 0" class="max-limit-message">
                    {{'Maximum characters reached' | translate | async}}
                </span>
            </div>
        </div>
        <div class="notes-action-buttons">
            <ng-container *ngIf="isEditMode">
                <a class="button cancel-btn" (click)="resetEditMode()">
                    <i class="material-icons button__icon">
                        close
                    </i>
                    <span class="button__text">
                        {{'Cancel' | translate | async}}
                    </span>
                </a>
                <a class="button button--primary save-btn" (click)="updateSummaryNotes()">
                    <i class="material-icons button__icon">
                        edit
                    </i>
                    <span class="button__text">
                        {{'Update' | translate | async}}
                    </span>
                </a>
            </ng-container>
            <ng-container *ngIf="!isEditMode">
                <a class="button reset-btn" (click)="resetCommentText()">
                    <i class="material-icons button__icon">
                        restart_alt
                    </i>
                    <span class="button__text">
                        {{'Reset' | translate | async}}
                    </span>
                </a>
                <a class="button button--primary save-btn" (click)="saveSummaryNotes()">
                    <i class="material-icons button__icon">
                        save
                    </i>
                    <span class="button__text">
                        {{'Save' | translate | async}}
                    </span>
                </a>
            </ng-container>
        </div>
    </div>

    <div class="history-section">
        <div class="history-title">
            {{historyTitle | translate | async}}
        </div>
        <div class="history-table-container">
            <table class="history-table table--striped">
                <thead>
                    <tr>
                        <th>{{'Created On' | translate | async}}</th>
                        <th>{{'Created By' | translate | async}}</th>
                        <th>{{'Summary Notes' | translate | async}}</th>
                        <th>{{'Last Modified On' | translate | async}}</th>
                        <th>{{'Last Modified By' | translate | async}}</th>
                        <th>{{'Active' | translate | async}}</th>
                        <th>{{'Edit' | translate | async}}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let item of commentsHistory">
                        <td>{{item.CreatedDate}}</td>
                        <td>{{item.CreatedBy | aesDecrypt}}</td>
                        <td class="summary-notes-cell">
                            <div class="summary-notes-content" [class.expanded]="item.IsExpanded">
                                {{ item.SummaryNotes }}
                            </div>
                            <div *ngIf="item.SummaryNotes?.length > 120" class="show-more-btn"
                                (click)="item.IsExpanded = !item.IsExpanded">
                                <span *ngIf="!item.IsExpanded">
                                    {{'Show More' | translate | async}}
                                </span>
                                <span *ngIf="item.IsExpanded">
                                    {{'Show Less' | translate | async}}
                                </span>
                            </div>
                        </td>
                        <td>{{item.ModifiedDate ? (item.ModifiedDate) : ''}}</td>
                        <td>{{item.ModifiedBy ? (item.ModifiedBy | aesDecrypt) : ''}}</td>
                        <td>
                            <mat-checkbox color="primary" [(ngModel)]="item.IsActive" (change)="onActiveChange(item)">
                            </mat-checkbox>
                        </td>
                        <td>
                            <mat-icon class="edit-icon" (click)="editSummaryNotes(item)"
                                matTooltip="Edit Summary Notes">
                                edit
                            </mat-icon>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>